/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exclusive_Digital_Content_UnloInputs */

const en_exclusive_digital_content_unlo = /** @type {(inputs: Exclusive_Digital_Content_UnloInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exclusive digital content unlocks after purchase.`)
};

const es_exclusive_digital_content_unlo = /** @type {(inputs: Exclusive_Digital_Content_UnloInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El contenido digital exclusivo se desbloquea tras la compra.`)
};

const fr_exclusive_digital_content_unlo = /** @type {(inputs: Exclusive_Digital_Content_UnloInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le contenu numérique exclusif se débloque après l'achat.`)
};

const de_exclusive_digital_content_unlo = /** @type {(inputs: Exclusive_Digital_Content_UnloInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exklusiver digitaler Inhalt wird nach dem Kauf freigeschaltet.`)
};

const ja_exclusive_digital_content_unlo = /** @type {(inputs: Exclusive_Digital_Content_UnloInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`限定デジタルコンテンツは購入後にロック解除されます。`)
};

const zh_exclusive_digital_content_unlo = /** @type {(inputs: Exclusive_Digital_Content_UnloInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`购买后解锁专享数字内容。`)
};

const ar_exclusive_digital_content_unlo = /** @type {(inputs: Exclusive_Digital_Content_UnloInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`يتم فتح المحتوى الرقمي الحصري بعد الشراء.`)
};

const id_exclusive_digital_content_unlo = /** @type {(inputs: Exclusive_Digital_Content_UnloInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konten digital eksklusif terbuka setelah pembelian.`)
};

const it_exclusive_digital_content_unlo = /** @type {(inputs: Exclusive_Digital_Content_UnloInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il contenuto digitale esclusivo si sblocca dopo l'acquisto.`)
};

const ru_exclusive_digital_content_unlo = /** @type {(inputs: Exclusive_Digital_Content_UnloInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Эксклюзивный цифровой контент разблокируется после покупки.`)
};

const pt_exclusive_digital_content_unlo = /** @type {(inputs: Exclusive_Digital_Content_UnloInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conteúdo digital exclusivo desbloqueia após a compra.`)
};

const ko_exclusive_digital_content_unlo = /** @type {(inputs: Exclusive_Digital_Content_UnloInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`독점 디지털 콘텐츠는 구매 후 잠금 해제됩니다.`)
};

/**
* | output |
* | --- |
* | "Exclusive digital content unlocks after purchase." |
*
* @param {Exclusive_Digital_Content_UnloInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const exclusive_digital_content_unlo = /** @type {((inputs?: Exclusive_Digital_Content_UnloInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exclusive_Digital_Content_UnloInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_exclusive_digital_content_unlo(inputs)
	if (locale === "es") return es_exclusive_digital_content_unlo(inputs)
	if (locale === "fr") return fr_exclusive_digital_content_unlo(inputs)
	if (locale === "de") return de_exclusive_digital_content_unlo(inputs)
	if (locale === "ja") return ja_exclusive_digital_content_unlo(inputs)
	if (locale === "zh") return zh_exclusive_digital_content_unlo(inputs)
	if (locale === "ar") return ar_exclusive_digital_content_unlo(inputs)
	if (locale === "id") return id_exclusive_digital_content_unlo(inputs)
	if (locale === "it") return it_exclusive_digital_content_unlo(inputs)
	if (locale === "ru") return ru_exclusive_digital_content_unlo(inputs)
	if (locale === "pt") return pt_exclusive_digital_content_unlo(inputs)
	return ko_exclusive_digital_content_unlo(inputs)
});